var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.83334C4.32465 1.83334 1.33398 4.82401 1.33398 8.50001C1.33398 12.176 4.32465 15.1667 8.00065 15.1667C11.6767 15.1667 14.6673 12.176 14.6673 8.50001C14.6673 4.82401 11.6767 1.83334 8.00065 1.83334ZM8.00065 13.8333C5.05998 13.8333 2.66732 11.4407 2.66732 8.50001C2.66732 5.55934 5.05998 3.16668 8.00065 3.16668C10.9413 3.16668 13.334 5.55934 13.334 8.50001C13.334 11.4407 10.9413 13.8333 8.00065 13.8333Z",
    fill: "#20A8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 5.16666H7.33398V8.77599L9.52932 10.9713L10.472 10.0287L8.66732 8.22399V5.16666Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.0f0e37e5f307f1b7b4b13f3fd3e1ec1d.svg";
export { ForwardRef as ReactComponent };